<h2 mat-dialog-title>{{ data.title }}</h2>

<div mat-dialog-content>
    <div [innerHTML]="data.message"></div>

    @if (requiresConfirmationKeyword) {
        <mat-form-field appearance="outline" class="mt-5">
            <mat-label>Type {{ confirmationKeyword }} to continue.</mat-label>
            <input id="dialog-confirmation-keyword" matInput type="text" [value]="confirmationKeywordValue" (input)="onConfirmationKeywordInput($event)" autocomplete="off" autocapitalize="none" spellcheck="false" />
        </mat-form-field>
    }
</div>

<div mat-dialog-actions>
    <button mat-stroked-button [mat-dialog-close]="false" cdkFocusInitial>
        {{ data.cancelButtonLabel ?? 'Cancel' }}
    </button>

    @if (data.type === 'confirm') {
        <button mat-raised-button [mat-dialog-close]="true" [disabled]="!canConfirm" color="primary">
            {{ data.confirmButtonLabel ?? 'Ok' }}
        </button>
    }

    @if (data.type === 'danger') {
        <button mat-raised-button [mat-dialog-close]="true" [disabled]="!canConfirm" color="warn">
            {{ data.confirmButtonLabel ?? 'Ok' }}
        </button>
    }

    @if (data.type === 'danger-outline') {
        <button mat-stroked-button [mat-dialog-close]="true" [disabled]="!canConfirm" color="warn">
            {{ data.confirmButtonLabel ?? 'Ok' }}
        </button>
    }
</div>
